/**
 * Procedure-payment settings API.
 *
 * Three clinic-wide flags governing how procedure payments flow:
 *   - skip_payment_all           — skip the payment step for every procedure
 *   - doctor_can_collect_payment — let doctors collect (else front-desk only)
 *   - auto_complete_procedures   — auto-complete a procedure once its payment
 *                                  is collected (or added, under skip-payment),
 *                                  without waiting for doctor sign-off
 *
 * The first two flags are read-only here — they're set via the backend admin
 * script (scripts/admin/payment_policy.py), not the app UI. `auto_complete_procedures`
 * is admin-writable from the app (Fees & Billing panel) via the PUT below.
 *
 * Backend: GET / PUT /api/organisation/settings/procedure-payment
 * PUT is a partial update — an omitted field keeps its current value.
 */
import apiClient from './apiClient';

export const getProcedurePaymentSettings = async () => {
  const res = await apiClient.get('/api/organisation/settings/procedure-payment');
  return res.data;
};

/**
 * Partial update. Only `auto_complete_procedures` is exposed for write this
 * wave; other fields keep their server value if omitted.
 *   patch: { auto_complete_procedures?: bool }
 */
export const updateProcedurePaymentSettings = async (patch = {}) => {
  const body = {};
  if (patch.auto_complete_procedures != null) {
    body.auto_complete_procedures = !!patch.auto_complete_procedures;
  }
  const res = await apiClient.put('/api/organisation/settings/procedure-payment', body);
  return res.data;
};
